import React from "react";
import { Link } from "react-router-dom";
import { Menu, X, LogOut } from "lucide-react";
import { LanguageToggle } from "@/components/LanguageToggle";
import { ThemePaletteToggle } from "@/components/ThemePaletteToggle";

const NAV = [
  { to: "/about", key: "about" },
  { to: "/how-it-works", key: "how_it_works" },
  { to: "/for-msmes", key: "for_msmes" },
  { to: "/for-banks", key: "for_banks" },
  { to: "/schemes", key: "schemes" },
  { to: "/cgtmse", key: "cgtmse" },
];

export function PublicHeader({ user, locPath, useLightHeader, mobileOpen, onToggleMobile, onLogout, t }) {
  const headerClass = useLightHeader
    ? "bg-transparent border-transparent text-white"
    : "bg-[color:var(--bk-ivory)]/95 backdrop-blur-xl border-b border-[color:var(--bk-line)] text-[color:var(--bk-navy)]";
  const textShadow = useLightHeader ? { textShadow: "0 1px 3px rgba(0,0,0,0.35)" } : undefined;

  return (
    <header className={`sticky top-0 z-40 transition-colors ${headerClass}`}>
      {useLightHeader && (
        <div aria-hidden className="absolute inset-x-0 top-0 h-24 pointer-events-none" style={{ background: "linear-gradient(to bottom, rgba(11,18,32,0.55), rgba(11,18,32,0))" }} />
      )}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-md grid place-items-center brand-heading font-bold text-[12px] shadow-sm" style={{ background: useLightHeader ? "#fff" : "var(--bk-navy)", color: useLightHeader ? "var(--bk-navy)" : "#fff" }}>BK</div>
          <div className="leading-tight" style={textShadow}>
            <div className="brand-heading font-semibold text-[15px]">BharatKosh</div>
            <div className="text-[10px] uppercase tracking-widest opacity-70">Loan Bazaar</div>
          </div>
        </Link>
        <nav className="hidden md:flex items-center gap-6 lg:gap-8 text-sm" style={textShadow}>
          {NAV.map((n) => (
            <Link key={n.key} to={n.to} data-testid={`pubnav-${n.key}`} className={`transition-colors ${locPath === n.to ? "font-semibold" : "opacity-90 hover:opacity-100"}`}>
              {t(n.key)}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-2 sm:gap-3">
          <ThemePaletteToggle dark={useLightHeader} />
          <div className="hidden sm:block"><LanguageToggle dark={useLightHeader} /></div>
          {user ? (
            <>
              <Link to="/dashboard" data-testid="header-dashboard-btn" className="btn-primary !py-2 !px-4 !text-xs">{t("dashboard")}</Link>
              <button onClick={onLogout} data-testid="header-logout-btn" title={t("logout")}
                className={`hidden sm:inline-flex items-center gap-1.5 rounded-full border px-3 py-2 text-xs font-semibold transition-colors ${useLightHeader ? "border-white/60 text-white bg-white/15 backdrop-blur-md hover:bg-white/25" : "border-[color:var(--bk-line)] text-[color:var(--bk-navy)] bg-white hover:border-[color:var(--bk-navy)]/40"}`}>
                <LogOut className="w-3.5 h-3.5" /> {t("logout")}
              </button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="header-login-btn" className={`hidden sm:inline text-sm font-medium ${useLightHeader ? "text-white hover:text-white/90" : "text-[color:var(--bk-navy)]/85 hover:text-[color:var(--bk-navy)]"}`} style={textShadow}>{t("login")}</Link>
              <Link to="/register" data-testid="header-register-btn" className="hidden sm:inline-flex btn-primary !py-2 !px-4 !text-xs">{t("register")}</Link>
            </>
          )}
          <button onClick={onToggleMobile} className={`md:hidden inline-flex items-center justify-center w-10 h-10 rounded-full border ${useLightHeader ? "border-white/60 text-white bg-white/15 backdrop-blur-md" : "border-[color:var(--bk-line)] text-[color:var(--bk-navy)] bg-white"} shadow-sm`} aria-label="Toggle menu" data-testid="pub-menu-toggle">
            {mobileOpen ? <X className="w-5 h-5" strokeWidth={2.25} /> : <Menu className="w-5 h-5" strokeWidth={2.25} />}
          </button>
        </div>
      </div>
    </header>
  );
}

export { NAV as PUBLIC_NAV };
